interface Props {
  text: string;
  highlight: string;
  highlightClass: string;
}
const HighlightText: React.FC<Props> = ({
  text,
  highlight,
  highlightClass,
}) => {
  const parts = text.split(new RegExp(`(${highlight})`, "gi"));
  return (
    <span className="p-0">
      {parts.map((str, key) => (
        <span
          key={key}
          className={`${
            str.toLowerCase() === highlight.toLowerCase() ? highlightClass : ""
          }`}
        >
          {str}
        </span>
      ))}
    </span>
  );
};

export default HighlightText;
